import styled from 'styled-components';

export const BatterViewWrapper = styled.div`
  padding-bottom: 15px;
`;
